module.exports = __webpack_public_path__ + "static/media/pre-select-staff.03178ba0.png";